import { FC, useEffect } from 'react'
import { GetServerSideProps } from 'next'

import LibrarySearchLayout from 'containers/library-layout/library-layout'
import SEOMetatags from 'components/parts/seo-metatags/seo-metatags'
import SEOBreadCrumbs from 'components/parts/seo-metatags/seo-breadcrumbs'

import nestRequest from 'utils/server-side/nestRequest'
import { SEOType } from 'constants/SEO'
import { LibraryPageClinicBC } from 'constants/SEO-breadcrumbs'
import { INewslineCard } from 'constants/types/card.types'
import { PLACEFLAG_LIBRARY } from 'constants/analytic-data'
import { CARDS_ON_PAGE } from 'constants/search-data/search-data'
import { A_l_sectionToggle, sectionName } from 'utils/analytics/library/library'
import { useARegAndLogin, originReg } from 'utils/analytics/other/registration/registration'

const PAGE_LIMIT = 2

const LibraryClinicSEO = (page: number) => {
  const pageString = page >= 2 ? ` - Страница ${page}` : ''
  return {
    [SEOType.TITLE]: `Клинические рекомендации для врачей 2024 ${pageString}`,
    [SEOType.DESCRIPTION]: `Рубрикатор клинических рекомендаций 2024 для взрослых и детей на сайте Medpoint.pro ${pageString}}`,
    [SEOType.LINK]: `${URL}/library/clinic`,
    [SEOType.PLACE]: PLACEFLAG_LIBRARY,
  }
}

interface ILibraryClinic {
  pageValue: number
  initCards: {
    count: number
    rows: INewslineCard[]
  }
}

const LibraryClinic: FC<ILibraryClinic> = ({ pageValue, initCards }) => {
  const titlePage =
    pageValue >= PAGE_LIMIT
      ? `Клинические рекомендации для врачей <span>Cтраница ${pageValue}</span>`
      : 'Клинические рекомендации для врачей'

  useARegAndLogin(originReg.LIBRARY)
  useEffect(() => {
    A_l_sectionToggle(sectionName.CLINREC)
  }, [])

  return (
    <>
      <SEOMetatags data={LibraryClinicSEO(pageValue)} />
      <SEOBreadCrumbs data={LibraryPageClinicBC} />
      <LibrarySearchLayout initCards={initCards} title={titlePage} />
    </>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  let initCards = null

  const offset = context.query.page ? CARDS_ON_PAGE * (Number(context.query.page) - 1) : 0

  const articleSearchParams = {
    offset: offset,
    limit: CARDS_ON_PAGE,
    count: true,
    ArticleTypeId: 3,
  }

  try {
    const clinicRequest = await nestRequest(context, 'get', `/api/article`, articleSearchParams)
    initCards = clinicRequest?.data

    if (clinicRequest.status !== 200) throw new Error('rest request error')
  } catch (err) {
    console.log(err)
  }

  return {
    props: {
      initCards,
      pageValue: context.query.page || 1,
    },
  }
}

export default LibraryClinic
